module.exports = __webpack_public_path__ + "img/home.4707f25b.png";